import { render } from "./SiteNavigation.vue?vue&type=template&id=2822aecc"
import script from "./SiteNavigation.vue?vue&type=script&lang=js"
export * from "./SiteNavigation.vue?vue&type=script&lang=js"

import "./SiteNavigation.vue?vue&type=style&index=0&id=2822aecc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__